import { render } from "./index.vue?vue&type=template&id=01147838&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=01147838&lang=less&scoped=true"

import exportComponent from "/Users/gejiayang/Desktop/chunlin-overseas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01147838"]])

export default __exports__